/**
 * Der feste Schlüssel des Empfängers „Stage-Preview" bei Message (Nutzer, 2026-10-25).
 *
 * ⭐ **Ein eigenes Paar, nicht Inks.** Teilten sich beide Apps einen Schlüssel, öffnete Ink auch
 * eine Stage-Preview und umgekehrt. Relay wählt den Empfänger nach `metadata.target`.
 *
 * ⚠️ **Der private Teil steht absichtlich im Code** und ist damit aus App und Web-JS auslesbar.
 * Wer ihn und einen Preview-QR hat, liest die Prüfung. Getragen, weil eine Preview nur
 * Simulationsprüfungen bringt und jedes Gerät sie öffnen können soll (dieselbe Abwägung wie bei
 * Ink). Der öffentliche Teil liegt in `docs/Stage-Preview.pub.pem` und gehört bei Message nach
 * `certs/Stage-Preview.pub.pem`. Dasselbe Paar dient RSA-OAEP (Entschlüsseln) und RSA-PSS
 * (Signieren), so verlangt es der Vertrag.
 */
export const PREVIEW_PRIVATE_KEY_PEM = `-----BEGIN PRIVATE KEY-----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-----END PRIVATE KEY-----
`;

/** Der Empfänger bei Message. */
export const PREVIEW_RECIPIENT = 'Stage-Preview';

export interface PreviewKeys {
  decrypt: CryptoKey;
  sign: CryptoKey;
}

const pkcs8 = (pem: string): ArrayBuffer => {
  const b64 = pem.replace(/-----[^-]+-----/g, '').replace(/\s+/g, '');
  const raw = atob(b64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return bytes.buffer;
};

let cached: Promise<PreviewKeys> | null = null;

/** Dasselbe PKCS#8 zweimal: WebCrypto bindet einen Schlüssel an genau ein Verfahren. */
export function importPreviewKeys(pem: string = PREVIEW_PRIVATE_KEY_PEM): Promise<PreviewKeys> {
  if (pem !== PREVIEW_PRIVATE_KEY_PEM) return importKeys(pem);
  cached ??= importKeys(pem);
  return cached;
}

async function importKeys(pem: string): Promise<PreviewKeys> {
  const der = pkcs8(pem);
  const [decrypt, sign] = await Promise.all([
    crypto.subtle.importKey('pkcs8', der, { name: 'RSA-OAEP', hash: 'SHA-256' }, false, ['decrypt']),
    crypto.subtle.importKey('pkcs8', der, { name: 'RSA-PSS', hash: 'SHA-256' }, false, ['sign']),
  ]);
  return { decrypt, sign };
}
